import React from "react";
import Box from "@mui/material/Box";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { Clear } from "@mui/icons-material";
import { th } from "date-fns/locale";

const DateSelected = ({
  isSmallerThanTablet = false,
  dateLabel = "",
  dataSearch = {},
  setDataSearch = () => {},
  isFullWidth = false,
}) => {
  return (
    <Box
      sx={{
        display: isSmallerThanTablet ? "none" : "flex",
        width: "100%",
        minWidth: "140px",
        maxWidth: isFullWidth ? "100%" : "200px",

        "& .MuiFormControl-root": {
          width: "100%",
        },
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={th}>
        <DatePicker
          label={dateLabel}
          value={dataSearch.date}
          onChange={(newValue) =>
            setDataSearch((prev) => ({
              ...prev,
              date: newValue,
              page: 0,
            }))
          }
          format="dd/MM/yyyy"
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {dataSearch.date && (
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setDataSearch((prev) => ({
                            ...prev,
                            date: null,
                            page: 0,
                          }));
                        }}
                      >
                        <Clear />
                      </IconButton>
                    )}
                    {params.InputProps?.endAdornment}
                  </>
                ),
              }}
            />
          )}
          sx={{ width: "100%" }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default DateSelected;
